export const textColor = (value: number | undefined) => {
  if (value === 100) return '#6c757d';
  if (value && value > 0) return '#28a745';
  if (value && value < 0) return '#dc3545';
  return '#6c757d';
};

export const arrowSrc = (value: number | undefined) => {
  if (value === 100) return undefined;
  if (value && value > 0) return '/media/icons/dash/up.png';
  if (value && value < 0) return '/media/icons/dash/down.png';

  return null;
};

export const arrow = (v: unknown) => {
  const n = Number(v ?? 0);
  if (n === 100) return '→';
  return n > 0 ? '↑' : n < 0 ? '↓' : '→';
};

export const pct = (v: unknown) =>
  v === 100 ? '0.00' : Math.abs(Number(v ?? 0)).toFixed(2);
